import React, { useState, useRef, useEffect } from 'react';
import { sendMessage } from './services/BedrockService';
import './App.css';

function App() {
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const messagesEndRef = useRef(null);

  const logoUrl = 'https://es.danaconnect.com/wp-content/uploads/logo-danaconnect-header.png';

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;

    const userMessage = { text: inputMessage, sender: 'user' };
    setMessages(prevMessages => [...prevMessages, userMessage]);
    setInputMessage('');
    setIsLoading(true);
    setError(null);

    try {
      const response = await sendMessage(inputMessage);
      const botMessage = { 
        text: response.answer || 'Lo siento, no pude procesar tu solicitud.', 
        sender: 'bot' 
      };
      setMessages(prevMessages => [...prevMessages, botMessage]);
    } catch (error) {
      console.error('Error completo:', error);
      
      let errorMessage = 'Hubo un error al conectar con el servicio.';
      
      if (error.response) {
        errorMessage = `Error del servidor: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = 'No se recibió respuesta del servidor.';
      }

      const botErrorMessage = { 
        text: errorMessage, 
        sender: 'bot' 
      };
      
      setMessages(prevMessages => [...prevMessages, botErrorMessage]);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopy = async (text, index) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch (err) {
      console.error('No se pudo copiar el texto:', err);
    }
  };

  return (
    <div className="chat-container">
      <header className="chat-header">
        <img 
          src={logoUrl} 
          alt="DANAconnect Logo" 
          className="logo" 
        />
        <h1>HANA - Asistente de Seguridad</h1>
      </header>
      
      <main className="chat-main">
        <div className="messages">
          {messages.map((message, index) => (
            <div 
              key={index} 
              className={`message ${message.sender}`}
            >
              {message.text}
              {message.sender === 'bot' && (
                <button 
                  className="copy-button"
                  onClick={() => handleCopy(message.text, index)}
                >
                  {copiedIndex === index ? '✅ Copiado' : '📋 Copiar'}
                </button>
              )}
            </div>
          ))}
          {isLoading && (
            <div className="message bot typing-indicator">
              Escribiendo...
            </div>
          )}
          {error && (
            <div className="message bot error">
              {error}
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
        
        <form onSubmit={handleSendMessage} className="chat-input">
          <input
            type="text"
            placeholder="Escribe tu pregunta..."
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            disabled={isLoading}
          />
          <button 
            type="submit" 
            disabled={isLoading || !inputMessage.trim()}
          >
            Enviar
          </button>
        </form>
      </main>
    </div>
  );
}

export default App;
